import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

import modules from "./modules/index.js";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules,
  pluguns: debug ? [createLogger()] : []
});

export default store;
